var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('app-header'),_vm._v(" "),_c('mpn-page-title',{attrs:{"title":_vm.pageTitle}}),_vm._v(" "),_c('phase-bar',{attrs:{"phase":_vm.phase}}),_vm._v(" "),_c('router-view',{on:{"phase-change":_vm.onPhaseChange}}),_vm._v(" "),_c('app-footer')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a902ee1c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/composition/main/Composition.vue
// module id = null
// module chunks = 